export default Object.freeze({
  DateChange: 1,
  ScheduleChange: 2,
  ChangeParticipant: 3,
});
